import { httpInterceptor } from '../http-interceptor';

export class PrintLabelService {
  static ENDPOINTS = {
    SAVE_PRINT_LABEL_REQUEST: 'mobile/saveprintrequest',
    GET_PRINTERS: 'mobile/printers',
    GET_PRINT_CATEGORIES: 'mobile/printcategories',
    GET_PRINT_STATUSES: 'mobile/printstatus',
  };

  static async savePrintLabelRequest(data) {
    return httpInterceptor.post(this.ENDPOINTS.SAVE_PRINT_LABEL_REQUEST, data);
  }

  static async getPrinters() {
    return httpInterceptor.get(this.ENDPOINTS.GET_PRINTERS);
  }

  static async getPrintCategories() {
    return httpInterceptor.get(this.ENDPOINTS.GET_PRINT_CATEGORIES);
  }

  static async getPrintStatuses() {
    return httpInterceptor.get(this.ENDPOINTS.GET_PRINT_STATUSES);
  }
}
